export const PAGE_EVENTS = {
  CTA_CLICKED: "cta_clicked",
  FORM_SUBMITTED: "form_submitted",
  PAGE_VIEWED: "page_viewed",
} as const;

export const PROFILE_EVENTS = {
  NPS_JOB_VIEWS_THRESHOLD_REACHED: "nps_job_views_threshold_reached",
  JOB_SEEKING_STATUS_CHANGED: "job_seeking_status_changed",
} as const;

export const CTA_NAMES = {
  QUICK_APPLY: "quick_apply",
  EXTERNAL_APPLY: "external_apply",
  SALARY_SCHEDULE: "salary_schedule",
} as const;

export const FORM_NAMES = {
  EXPRESS_INTEREST: "express_interest",
  MATCH_ACCEPTED: "match_accepted",
  AUTH: "auth",
} as const;
